import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import routes from 'app/routes';

export default function StepSession({ step, topic, readOnly }) {
  return (
    <div className="selected-topic icon-with-text">
      <div className="counting-icon" />

      <div className="text-content w-100 d-flex align-items-center">
        <div className="flex-grow-1">
          {topic ? topic.title : step.title}
        </div>

        {!readOnly && step.is_topic_changeable && (
          <Link
            to={routes.members.programs.program.step.changeTopic(step.id)}
            className="btn btn-primary btn-sm"
            preventScrollReset
          >
            Change Topic
          </Link>
        )}
      </div>
    </div>
  );
}

StepSession.propTypes = {
  step: PropTypes.object.isRequired,
  topic: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
};

StepSession.defaultProps = {
  readOnly: false,
};
